import { DcEnvironmentCode } from '../../instance';

type Protocol = 'https://' | 'http://';

export function getProtocolByEnivironment(environment: DcEnvironmentCode): Protocol {
  return environment === 'local' ? 'http://' : 'https://';
}

export function getHost(prefix: string, domain: string, tld: string, hostPrefix = ''): string {
  return `${prefix}${hostPrefix}.${domain}.${tld}`;
}

export function getBaseUrl(baseUrl: string) {
  const url = new URL('/', baseUrl);
  return url.toString();
}

export function appendPathToUrl(path: string | string[], baseUrl: string | URL): string {
  const url = typeof baseUrl === 'string' ? baseUrl : baseUrl.toString();
  const cleanedPath = Array.isArray(path) ? path.map((str) => str.split('/').filter(Boolean)).join('/') : path;
  const combinedUrl = new URL(cleanedPath, url);
  return combinedUrl.toString();
}
